import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PortfolioLoadingService, PortfolioStatsService } from '@services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  isLoading = true;
  activeStudiesCount = 0;
  countriesCount = 0;
  subjectsEnrolledCount = 0;

  portfolioStatsService = inject(PortfolioStatsService);
  portfolioLoadingService = inject(PortfolioLoadingService);

  ngOnInit(): void {
    this.subscriptions.add(
      this.portfolioLoadingService.isLoading$.subscribe((isLoading) => {
        this.isLoading = isLoading;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.activeStudiesCount$.subscribe((count) => {
        this.activeStudiesCount = count;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.countriesCount$.subscribe((count) => {
        this.countriesCount = count;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.subjectsEnrolledCount$.subscribe((count) => {
        this.subjectsEnrolledCount = count;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
